query DisputesList($page: Int, $rowsPerPage: Int, $filter: DisputesFilterInput) {
  disputes(page: $page, rowsPerPage: $rowsPerPage, filter: $filter) {
    count
    nodes {
      id
      amount {
        value
        currency
      }
      organizationAmountInOrganizationCurrency {
        value
        currency
      }
      status
      createdAt
      payment {
        buyerEmail
        userId
        provider
        product {
          id
          title
          type
        }
      }
    }
  }
}
